export default __webpack_public_path__ + "static/media/869.2ccfeaec.png";